import request from '../../utils/request';
import { Search } from '@/DTOS/InfoDevice/Search';

const DeviceTypeService = {
  search: (search: Search) => {
    return request('/deviceType/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      systemTypeId: any;
      name: any;
      price: any;
      addition: any;
      producer: any;
      provider: any;
      model: any;
      laborTimeSM: any;
      laborPriceSM: any;
      laborTimePM: any;
      laborPricePM: any;
      minRecomandation: any;
      maxRecomandation: any;
      imageLink: any;
      deviceTypeLabors: any;
      isActive: any,
    }
  ) => {
    const handleFieldValue = (fieldValue: any) => {
      if (Array.isArray(fieldValue)) {
        return fieldValue;
      } else {
        return [fieldValue];
      }
    };
    return request('/deviceType/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          systemTypeId: formData.systemTypeId,
          name: formData.name,
          price: formData.price,
          addition: formData.addition,
          producer: formData.producer,
          provider: formData.provider,
          model: formData.model,
          laborTimeSM: formData.laborTimeSM,
          laborPriceSM: formData.laborPriceSM,
          laborTimePM: formData.laborTimePM,
          laborPricePM: formData.laborPricePM,
          minRecomandation: formData.minRecomandation,
          maxRecomandation: formData.maxRecomandation,
          imageLink: handleFieldValue(formData.imageLink),
          deviceTypeLabors: formData.deviceTypeLabors,
          isActive: formData.isActive
        },
      }),
    });
  },
};

export default DeviceTypeService;
